import { Env, readFromEnv } from '@cinch-nx/environments'
import SitesClient, {
  AttributeFilters,
  NearestSitesConfig,
  Site,
  SiteWithDistance,
} from '@cinch-labs/sites-sdk'

const createClient = () =>
  new SitesClient(readFromEnv(Env.SitesBaseUrl), readFromEnv(Env.SitesApiKey))

export const getSite = async (siteId: string): Promise<Site | undefined> => {
  const client = createClient()

  try {
    return await client.getSite(siteId)
  } catch (error) {
    const e = new Error(
      `failed to get site with ID ${siteId}: ${
        error instanceof Error ? error.message : 'unknown error'
      }`,
    )

    throw e
  }
}

export const getSites = async (filters?: AttributeFilters): Promise<Site[]> => {
  const client = createClient()

  try {
    return await client.getSites(filters)
  } catch (error) {
    const e = new Error(
      `failed to get sites: ${
        error instanceof Error ? error.message : 'unknown error'
      }`,
    )

    throw e
  }
}

export const getNearestSites = async (
  postcode: string,
  config?: NearestSitesConfig,
): Promise<SiteWithDistance[]> => {
  const client = createClient()

  try {
    return await client.getNearestSites(postcode, config)
  } catch (error) {
    const e = new Error(
      `failed to get nearest sites: ${
        error instanceof Error ? error.message : 'unknown error'
      }`,
    )

    throw e
  }
}
